module.exports = __webpack_public_path__ + "img/logo_.5d3880a6.png";